// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1cuTv","obliqueLineWrap":"membershipbadge_obliqueLineWrap__37BVn","obliqueLine":"membershipbadge_obliqueLine__13APy"};